import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

export default function Terms() {
  return (
    <div className="min-h-screen bg-background pt-32 pb-16">
      <Helmet>
        <title>Terms of Service | Synthetic Trading Hub</title>
        <meta name="description" content="Read the terms and conditions for using Synthetic Trading Hub and its services." />
        <meta name="keywords" content="synthetic trading, synthetic indices trading, deriv trading guide, crash boom trading, trading for beginners, online trading platform" />
        <meta property="og:title" content="Terms of Service | Synthetic Trading Hub" />
        <meta property="og:description" content="Read the terms and conditions for using Synthetic Trading Hub and its services." />
        <meta property="og:url" content="https://synthetictradinghub.com/terms" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Terms of Service | Synthetic Trading Hub" />
        <meta name="twitter:description" content="Read the terms and conditions for using Synthetic Trading Hub and its services." />
        <meta name="twitter:image" content="https://images.unsplash.com/photo-1569025743873-ea3a9ade89f9" />
        <link rel="canonical" href="https://synthetictradinghub.com/terms" />
      </Helmet>
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 max-w-3xl">
        <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-6">Terms of Service</h1>
        <p className="text-sm text-gray-500 mb-8">Last updated: {new Date().toLocaleDateString('en-GB')}</p>

        <div className="prose prose-gray max-w-none space-y-6 text-gray-700">
          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-2">1. Acceptance</h2>
            <p>
              By using this website you agree to these terms. This site is an independent affiliate landing page
              that directs users to the official Deriv platform. We are not Deriv; we promote their services as an
              affiliate partner.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-2">2. Use of this site</h2>
            <p>
              You may use this site for lawful purposes only. You must not use it to misrepresent your identity,
              to attempt to collect others&apos; credentials, or for any fraudulent or illegal activity. Account
              opening and trading are carried out on the official Deriv website and are subject to Deriv&apos;s terms.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-2">3. Affiliate relationship</h2>
            <p>
              We may earn a commission when you sign up or trade through links on this site. This does not affect
              the terms or pricing you receive from Deriv. All contractual relationships for trading are between
              you and Deriv.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-2">4. Disclaimer</h2>
            <p>
              We do not guarantee the accuracy of information on this site. Trading involves risk. For the full
              risk disclosure, see our <Link to="/risk-disclosure" className="text-[#ff444f] hover:underline">Risk Disclosure</Link> page
              and Deriv&apos;s own terms and risk notices.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-gray-900 mb-2">5. Changes</h2>
            <p>
              We may update these terms. Continued use of the site after changes constitutes acceptance. Check the
              &quot;Last updated&quot; date for the current version.
            </p>
          </section>
        </div>

        <div className="mt-12 pt-8 border-t border-gray-200">
          <Link to="/" className="text-[#ff444f] font-semibold hover:underline">← Back to home</Link>
        </div>
      </div>
    </div>
  );
}
